export default __webpack_public_path__ + "static/media/rack.02036f63.svg";